import data from "../../.sourceflow/offices.json";
import CollectionHelper from "@/helpers/CollectionHelper";

class OfficesCollectionHelper extends CollectionHelper {
  regions() {
    return data.schema.find((i) => i.name === "Region").dropdown_values;
  }
}

export const offices_helper = new OfficesCollectionHelper(data);
